export class InviteUnsupportedStatus extends Error {
  public constructor() {
    super()

    this.message = 'invitePage.inviteErrors.unsupportedStatus'
  }
}
